import Vue from 'vue'
import VueResource from 'vue-resource'
import { container } from '../services/container'
Vue.use(VueResource)

export class PlansApi {
	constructor () {
		this.url = process.env.VUE_APP_API_URL
		this.access_token = container.get('services.oauth').getToken()
	}

	get (params) {
		return Vue.http.get(this.url + '/plan', {params: params, headers: {Authorization: 'Bearer ' + this.access_token}})
	}
};
